import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import './App.css';

import Homepage from "./pages/homepage";
import ComingSoon from "./pages/ComingSoon";

function App() {
  return (
    <div className="App">
			<Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/comingsoon" element={<ComingSoon />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
